"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var _1ds_core_js_1 = require("@microsoft/1ds-core-js");
var Constants_1 = require("../../../Constants");
var Logging_1 = require("../../../Logging");
var Types_1 = require("../../../Types");
var ReactNativeWindowsDevicePlugin = (function (_super) {
    __extends(ReactNativeWindowsDevicePlugin, _super);
    function ReactNativeWindowsDevicePlugin(componentName, xboxProductOnWindows, providerGuid, providerGroupGuid) {
        var _this = _super.call(this) || this;
        _this.RNWTelemetryProvider = null;
        var NativeModules = require("react-native").NativeModules;
        _this.RNWTelemetryProvider = NativeModules.RNWTelemetryProvider;
        if (!_this.RNWTelemetryProvider) {
            throw new Error("RNWTelemetryProvider not registered in react-native.");
        }
        if (xboxProductOnWindows || providerGuid || providerGroupGuid) {
            _this.RNWTelemetryProvider.registerGtlProviders(componentName, {
                xboxProductOnWindows: xboxProductOnWindows,
                providerGuid: providerGuid,
                providerGroupGuid: providerGroupGuid
            });
        }
        else {
            _this.RNWTelemetryProvider.registerGtlProviders(componentName);
        }
        _this.logger = new Logging_1.LogProvider("RNW-Uploader");
        return _this;
    }
    ReactNativeWindowsDevicePlugin.prototype.Unregister = function () {
        this.RNWTelemetryProvider.unregisterGtlProviders();
    };
    ReactNativeWindowsDevicePlugin.prototype.pause = function () { };
    ReactNativeWindowsDevicePlugin.prototype.resume = function () { };
    ReactNativeWindowsDevicePlugin.prototype.teardown = function () { };
    ReactNativeWindowsDevicePlugin.prototype.flush = function (async, callBack) { };
    ReactNativeWindowsDevicePlugin.prototype.processTelemetry = function (env, itemCtx) {
        var _a, _b;
        var eventData = env.data;
        var _meta = eventData._meta;
        delete eventData._meta;
        var privacyTag = (_a = _meta.GtlPrivacyTag, (_a !== null && _a !== void 0 ? _a : Types_1.PrivacyTag.ProductAndServiceUsage));
        var eventKeyword = (_b = _meta.GtlEventKeyword, (_b !== null && _b !== void 0 ? _b : Types_1.EventKeyword.Measure));
        if (env.baseType !== undefined && env.baseType !== "") {
            eventData.baseType = env.baseType;
            eventData.baseData = env.baseData;
            if (eventData.baseData.properties) {
                delete eventData.baseData.properties;
            }
        }
        var cvProperties = env.ext.mscv;
        if (cvProperties) {
            eventData[Constants_1.GTL_UTC_FIELD_NAME_CORRELATION_VECTOR] = cvProperties.cV;
        }
        var namespacePrefixLength = "Microsoft.Gaming.".length;
        var eventName = env.name.substring(env.name.indexOf(".", namespacePrefixLength) + 1);
        var logLevel = eventName === "Error" ? Types_1.LoggingLevel.Error : Types_1.LoggingLevel.Information;
        if (env.name.startsWith("Microsoft.Gaming.Critical.")) {
            this.RNWTelemetryProvider.writeCriticalEvent(eventName, privacyTag, logLevel, eventKeyword, eventData, _meta.GtlIsRequired);
        }
        else {
            if (_meta.GtlGroupIdType) {
                var groupId = void 0;
                if (_meta.GtlGroupIdType === Types_1.GtlGroupIdType.OptionalDiagnostic) {
                    groupId = this.RNWTelemetryProvider.GroupIds.DIAGNOSTIC;
                }
                else if (_meta.GtlGroupIdType === Types_1.GtlGroupIdType.CoreRequired) {
                    groupId = this.RNWTelemetryProvider.GroupIds.CORE;
                }
                else {
                    groupId = this.RNWTelemetryProvider.GroupIds.FUNCTIONAL;
                }
                this.RNWTelemetryProvider.writeEvent(eventName, privacyTag, logLevel, eventKeyword, eventData, groupId);
            }
            else {
                this.RNWTelemetryProvider.writeEvent(eventName, privacyTag, logLevel, eventKeyword, eventData);
            }
        }
    };
    return ReactNativeWindowsDevicePlugin;
}(_1ds_core_js_1.BaseTelemetryPlugin));
exports["default"] = ReactNativeWindowsDevicePlugin;
//# sourceMappingURL=ReactNativeWindowsDevicePlugin.js.map